import styled from 'styled-components';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.common.white};
  border-radius: 4px;
  box-shadow:
    0 20px 70px 0 rgba(0, 0, 0, 0.23),
    0 4px 15px 0 rgba(0, 0, 0, 0.28);
  width: 253px;
  z-index: 100;
  position: relative;
`;

export const ItemContainer = styled.div`
  padding: 8px;
  padding-right: 12px;
  display: flex;
  align-items: flex-start;
  cursor: pointer;

  &[data-active-item] {
    background: ${({ theme }) => theme.colors.neutrals[96]};
  }

  &[aria-disabled='true'] {
    opacity: 0.5;
  }
`;

export const ItemDetails = styled.div`
  padding: 2px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.45;
`;

export const ItemLabel = styled.p<{ variant?: 'regular' | 'danger' }>`
  margin: 0;
  color: ${(props) =>
    props.variant === 'danger'
      ? props.theme.colors.status.failure
      : props.theme.colors.text.normal};
`;

export const ItemDescription = styled(ItemLabel)`
  color: ${(props) => props.theme.colors.text.secondary};
  font-size: 12px;
`;

export const ItemIconContainer = styled.div<{ variant?: 'regular' | 'danger' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 2px;
  color: ${(props) =>
    props.variant === 'danger'
      ? props.theme.colors.status.failure
      : props.theme.colors.border.normal};
`;

export const MenuSeparatorStyles = styled.div`
  background: ${(props) => props.theme.colors.border.semi};
  height: 1px;
  width: 100%;
`;
